import {
  CloseOutlined,
  DeleteOutlined,
  LeftOutlined,
  PlusOutlined,
  RightOutlined,
} from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  TimePicker,
  Popconfirm,
  Row,
  Col,
  message,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import AddToCalendar from "react-add-to-calendar";
import { Calendar, momentLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useDispatch, useSelector } from "react-redux";
import HELPERS from "utils/helper";
import {
  addTaskAsync,
  deleteTaskAsync,
  selectProfile,
  selectTasks,
  updateTaskAsync,
  selectUpcomingMeetings,
} from "../../slices/dashboardSlice";
import "./Scheduler.css";
import DASHBOARD_API from "api/dashboard";

const localizer = momentLocalizer(moment);
const { TextArea } = Input;
const DragAndDropCalendar = withDragAndDrop(Calendar);

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.

export default function Scheduler() {
  const [modalVisible, setModalVisible] = useState(false);
  const [eventId, setEventId] = useState("");
  const [draggedEvent, setdraggedEvent] = useState("");
  const tasks = useSelector(selectTasks);
  // const upcomingMeetings = useSelector(selectUpcomingMeetings);
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);
  const profile = useSelector(selectProfile);
  const dispatch = useDispatch();
  const [addForm] = Form.useForm();
  const userId = HELPERS.getUserId();

  const [addToCal, setAddToCal] = useState("");
  const myEventsList = [];

  const CustomToolbar = (toolbar) => {
    HELPERS.log("Toolbar", toolbar);
    const goToBack = () => {
      toolbar.onNavigate("PREV");
    };
    const goToNext = () => {
      toolbar.onNavigate("NEXT");
    };
    const label = () => {
      return toolbar.label + "    " + toolbar.date.getFullYear();
    };

    return (
      <div style={{ padding: "30px 0", textAlign: "left" }}>
        <div style={{ display: "inline-block" }}>
          <LeftOutlined
            style={{
              opacity: "88%",
              fontSize: "24px",
              color: "#AEB7C2",
              padding: "0 10px",
            }}
            onClick={goToBack}
          />
          <RightOutlined
            style={{
              opacity: "88%",
              fontSize: "24px",
              color: "#AEB7C2",
              padding: "0 10px",
            }}
            onClick={goToNext}
          />
        </div>
        <label className="toolbar-label">{label()}</label>
      </div>
    );
  };

  const showModal = (start, end) => {
    let duration = moment.duration(moment(end).diff(moment(start)));
    setModalVisible(true);
    addForm.setFieldsValue({
      title: "New Task",
      date: moment(start),
      time: moment(start),
      duration: duration.asMinutes() - (duration.asMinutes() % 30),
      description: "",
      hyperlinks: [""],
    });

    setAddToCal({
      title: "New Task",
      description: "",
      location: "",
      startTime: start,
      endTime: end,
    });
  };

  const editEvent = (event) => {
    if (event.id < 1) return;

    setEventId(event.id);

    addForm.setFieldsValue({
      title: event.title,
      date: moment(event.start),
      time: moment(event.start),
      duration: event.duration,
      description: event.description,
      hyperlinks: event.hyperlinks.length > 0 ? event.hyperlinks : [""],
    });
    setModalVisible(true);

    let start_date = moment(event.start);
    console.log("start!!!!!!", start_date);

    setAddToCal({
      title: event.title,
      description: event.description,
      location: "",
      startTime: event.start,
      endTime: start_date.add(event.duration, "minutes").toDate(),
    });
  };

  tasks.forEach((task) => {
    let dueDate = moment(task.due_date);
    let duration = task.duration === 0 ? 60 : task.duration;
    let start = dueDate.toDate();
    // let end = dueDate.add(duration, "minutes").toDate();
    let end = moment(dueDate).add(duration, "minutes").toDate();
    // console.log('sss tasks start', task, start, end)
    myEventsList.push({
      title: task.title,
      start,
      end,
      allDay: false,
      description: task.description ? task.description : "",
      hyperlinks: task.hyperlinks.length > 0 ? task.hyperlinks : [""],
      id: task.id,
      duration: duration,
      coach: task.weekly_reflection > 0 || task.step_reflection > 0,
      upcoming_meeting: false,
    });
  });
  useEffect(() => {
    DASHBOARD_API.geAlltUpcomingMeetings(userId, true).then((resp) => {
      console.log(resp, "checking res upcoming")
      // dispatch(updateUpcomingMettingsFilters({}))
      if (resp && resp.data.upcoming_meetings) {
        // dispatch(updateUpcomingMettings(resp.data.upcoming_meetings))
        setUpcomingMeetings(resp.data.upcoming_meetings)
      }
    });
  }, [])
  console.log('sss upcomingMeetings time', upcomingMeetings)
  upcomingMeetings.forEach((meeting) => {
    const dueDate = moment(`${meeting.date} ${meeting.time}`, "YYYY-MM-DD hh:mm:ss A");
    const duration = 60;

    const start = dueDate.toDate();
    // const end = dueDate.add(duration, "minutes").toDate();
    const end = moment(dueDate).add(duration, "minutes").toDate();
    myEventsList.push({
      title: meeting.title,
      start,
      end,
      allDay: false,
      id: -1,
      coach: false,
      upcoming_meeting: true,
    });
  });

  if (profile && profile.daily_commitment) {
    var weekStart = moment().startOf("week");
    var days = {};
    days["sunday"] = moment(weekStart).add(0, "days");
    days["monday"] = moment(weekStart).add(1, "days");
    days["tuesday"] = moment(weekStart).add(2, "days");
    days["wednesday"] = moment(weekStart).add(3, "days");
    days["thursday"] = moment(weekStart).add(4, "days");
    days["friday"] = moment(weekStart).add(5, "days");
    days["saturday"] = moment(weekStart).add(6, "days");
    HELPERS.log("Weekdays", days);

    profile.daily_commitment.forEach((commitment) => {
      try {
        if (commitment.checked) {
          let time = commitment.time[0];
          time = time.split(" ");
          let hours = parseInt(time[0].split(":")[0]);
          let mins = parseInt(time[0].split(":")[1]);
          if (time[1].toUpperCase() !== "AM") {
            hours = 12 + (hours % 12);
          }

          HELPERS.log("The time is", commitment.time[0], hours, mins);

          let start = days[commitment.day].clone().set({
            hour: hours,
            minute: mins,
          });

          time = commitment.time[1];
          time = time.split(" ");
          hours = parseInt(time[0].split(":")[0]);
          mins = parseInt(time[0].split(":")[1]);
          if (time[1].toUpperCase() !== "AM") {
            hours = 12 + (hours % 12);
          }

          HELPERS.log("The time is", commitment.time[1], hours, mins);
          let end = days[commitment.day].clone().set({
            hour: hours,
            minute: mins,
          });

          myEventsList.push({
            title: "Focus on WOKEN",
            start: start.toDate(),
            end: end.toDate(),
            allDay: false,
            id: -1,
          });
        }
      } catch (error) {
        console.warn(error);
      }
    });
  }
  HELPERS.log("Event list", myEventsList);

  const onFinish = (values) => {
    var timeZoneFormatted = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
    const task = {
      title: values.title,
      due_date: `${values.date.format("YYYY-MM-DD")}T${values.time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`,
      duration: values.duration,
      description: values.description,
      hyperlinks: values.hyperlinks,
    };
    let add = true;
    for (var index = 0; index < tasks.length; ++index) {
      if (tasks[index].id === eventId) {
        dispatch(updateTaskAsync(eventId, task));
        add = false;
        break;
      }
    }
    if (add) {
      dispatch(addTaskAsync(task));
    }
    message.success("Your work has been saved")
    setModalVisible(false);
    setEventId("");
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSelect = ({ start, end }) => {
    console.log(start, end);
    showModal(start, end);
  };

  const handleCancel = () => {
    addForm.setFieldsValue({
      title: "",
      date: moment(),
      time: moment().add(1, "week"),
      duration: 60,
      description: "",
      hyperlinks: [""],
    });
    setModalVisible(false);
    setEventId("");
  };

  const handleDeleteTask = () => {
    dispatch(deleteTaskAsync(eventId));
    setModalVisible(false);
    setEventId("");
  };

  const moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
    let duration = moment.duration(end - start);
    const due_date = start;

    const task = {
      ...event,
      due_date: due_date,
      duration: duration.asMinutes() - (duration.asMinutes() % 30),
    };
    let add = true;
    for (var index = 0; index < tasks.length; ++index) {
      if (tasks[index].id === event.id) {
        dispatch(updateTaskAsync(event.id, task));
        add = false;
        break;
      }
    }
    if (add) {
      dispatch(addTaskAsync(task));
    }

    // const { events } = this.state

    // let allDay = event.allDay

    // if (!event.allDay && droppedOnAllDaySlot) {
    //   allDay = true
    // } else if (event.allDay && !droppedOnAllDaySlot) {
    //   allDay = false
    // }

    // const nextEvents = events.map(existingEvent => {
    //   return existingEvent.id == event.id
    //     ? { ...existingEvent, start, end }
    //     : existingEvent
    // })

    // this.setState({
    //   events: nextEvents,
    // })

    // alert(`${event.title} was dropped onto ${updatedEvent.start}`)
  };

  const resizeEvent = ({ event, start, end }) => {
    // const { events } = this.state

    // const nextEvents = events.map(existingEvent => {
    //   return existingEvent.id == event.id
    //     ? { ...existingEvent, start, end }
    //     : existingEvent
    // })

    // this.setState({
    //   events: nextEvents,
    // })

    //alert(`${event.title} was resized to ${start}-${end}`)
    let duration = moment.duration(end - start);
    const due_date = start;

    const task = {
      ...event,
      due_date: due_date,
      duration: duration.asMinutes() - (duration.asMinutes() % 30),
    };
    let add = true;
    for (var index = 0; index < tasks.length; ++index) {
      if (tasks[index].id === event.id) {
        dispatch(updateTaskAsync(event.id, task));
        add = false;
        break;
      }
    }
    if (add) {
      dispatch(addTaskAsync(task));
    }
  };

  const handleDragStart = (event) => {
    setdraggedEvent(event);
  };

  let formats = {
    dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
      localizer.format(start, "DD MMMM", culture) +
      " — " +
      localizer.format(end, "DD MMMM", culture),
  };

  const onFormChange = (val, allVal) => {
    let start_date = allVal.date;
    var timeZoneFormatted = new Date().toString().match(/([-\+][0-9]+)\s/)[1];

    let temp1 = moment(
      `${allVal.date.format("YYYY-MM-DD")}T${allVal.time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`
    );
    let end_time = temp1.add(allVal.duration, "minutes");
    console.log(
      allVal,
      `${allVal.date.format("YYYY-MM-DD")}T${allVal.time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`,
      `${end_time.format("YYYY-MM-DD")}T${end_time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`
    );
    setAddToCal({
      title: allVal.title,
      description: allVal.description,
      location: "",
      startTime: `${allVal.date.format("YYYY-MM-DD")}T${allVal.time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`,
      endTime: `${end_time.format("YYYY-MM-DD")}T${end_time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`,
    });
    console.log(
      allVal,
      `${allVal.date.format("YYYY-MM-DD")}T${allVal.time.format(
        "HH:mm:ss"
      )}${timeZoneFormatted}`
    );
  };
  useEffect(() => {
    const handleResize = () => {
      window.dispatchEvent(new Event("resize"));
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const today = new Date();
  return (
    <>
      <div style={{
        overflow: "auto",
        width: "100%",
      }}>
      <Calendar
        formats={formats}
        selectable
        localizer={localizer}
        events={myEventsList}
        // onEventDrop={moveEvent}
        // resizable
        // onEventResize={resizeEvent}
        // onDragStart={console.log}
        // handleDragStart={handleDragStart}
        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0)}     // 12:00 AM today
        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59)}  // 11:59 PM today
        eventPropGetter={(event) => ({
          style: { 
            backgroundColor: event.coach ? "#199094" : event.upcoming_meeting ? "#CB9433" : "#FFE4E1", 
            color: event.coach ? "#ffffff" : event.upcoming_meeting ? "#ffffff" : "#6E1D12" },
        })}
        startAccessor="start"
        endAccessor="end"
        showMultiDayTimes={true}
        defaultView="week"
        style={{ background: "white", marginTop: "7%" }}
        onSelectSlot={handleSelect}
        onSelectEvent={(event) => editEvent(event)}
        toolbar={true}
        components={{
          toolbar: CustomToolbar,
        }}
      />
      </div>
      {console.log("current!!!", eventId, tasks)}
      <Modal
        title=""
        visible={modalVisible}
        onCancel={handleCancel}
        footer={false}
        width="550px"
        destroyOnClose={true}
        closeIcon={<CloseOutlined className="close-icon" />}
        className="edit-task-modal"
      >
         <h2 class="modal-title">{eventId ? "Edit Task" : "Add New Task" }</h2>
        <Form
          name="add-task-form"
          initialValues={{}}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={addForm}
          layout="vertical"
          onValuesChange={onFormChange}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Name"
                name="title"
                className="edit-task-items"
                rules={[{ required: true, message: "Please input your title!" }]}
              >
                <Input placeholder="Title of my task" size="large" style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="description"
                className="edit-task-items"
                label="Description"
              >
                <TextArea placeholder="Describe the task" autoSize={{ minRows: 2, maxRows: 5 }} style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.List name="hyperlinks">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        key={field.key}
                        label={index === 0 ? "Hyperlink" : ""}
                        required={false}
                        className="edit-task-items"
                        style={{ marginBottom: index === fields.length - 1 ? 24 : 15 }}
                      >
                        <Form.Item
                          {...field}
                          noStyle
                        >
                          <Input
                            placeholder="Paste any helpful links here"
                            size="large"
                            style={{
                              padding: "13.5px 11px",
                              borderRadius: "12px",
                              boxSizing: "border-box",
                              width: "100%",
                              backgroundColor: "#E8F4F7",
                              border: "1px solid #007bff",
                              marginBottom: "10px"
                            }}
                              // suffix={
                              //   index > 0 ? (
                              //     <img src="https://django-woken-static.s3.amazonaws.com/static/media/delete.037bee2b.svg" width="16px" onClick={() => remove(field.name)}></img>
                              //   ) : null
                              // }
                            />
                        </Form.Item>
                        {
                          index === 0 &&
                          <button
                            type="button"
                            onClick={() => add()}
                            style={{
                              color: "#8E8E8E",
                              background: "none",
                              border: "none",
                              padding: 0,
                              fontSize: "17px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              columnGap: "5px",
                              // marginBottom: "20px",
                            }}
                          >
                            <PlusOutlined /> Add more
                          </button>
                        }
                      </Form.Item>
                    ))}
                  </>
                )}
              </Form.List>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={12}>
                  <Form.Item name="date" className="edit-task-items" label="Date">
                    <DatePicker style={{ margin: "0", padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ paddingLeft: "10px"}}>
                  <Form.Item name="time" className="edit-task-items" label="Time">
                    <TimePicker
                      use12Hours
                      format="h:mm a"
                      style={{ margin: "0", padding: "13.5px 11px", width: "100%", boxSizing: "border-box", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }}
                      // bordered={false}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={12} hidden>
              <Form.Item
                label="Duration (minutes)"
                name="duration"
                className="edit-task-items"
              >
                <InputNumber min={30} max={60 * 24} step={30} style={{ padding: "2.5px 11px", boxSizing: "border-box", backgroundColor: "#E8F4F7", border: "1px solid #007bff", borderRadius: "10px" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={8}>
                <div className="button-group" style={{ justifyContent: "flex-start" }}>
                  
                  <Popconfirm
                    title="Are you sure you want to delete?"
                    onConfirm={() => {
                      handleDeleteTask();
                    }}
                  >
                    <Form.Item style={{ maxWidth: "100px", display: "inline-block" }}>
                      <button
                        className="button-secondary"
                        disabled={!eventId}
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        >
                          <DeleteOutlined/>&nbsp;&nbsp;Delete
                      </button>
                    </Form.Item>
                  </Popconfirm>

                </div>
                </Col>
                <Col span={16}>
                  <div className="button-group">
                    <button
                      className="button-secondary"
                      type="button"
                      style={{
                        width: "100%"
                      }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="primary"
                      className="button-main"
                      htmlType="submit"
                      style={{
                        width: "100%"
                      }}
                    >
                      Save
                    </button>

                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={{ marginBottom: "20px" }}>
            {React.createElement(() => (
              <AddToCalendar
                event={addToCal}
                listItems={[{ google: "Add to Google Calendar" }]}
                optionsOpen={true}
              />
            ))}
          </div>
        </Form>
      </Modal>
    </>
  );
}